import React from "react";
import PropTypes from "prop-types";

const Modal = props => (
  <div className={`modal ${props.isActive && "is-active"}`}>
    <div className="modal-background" onClick={props.onClick} />
    <div className="modal-content" style={props.style}>
      {props.children}
    </div>
    <div className="modal-close" onClick={props.onClick} />
  </div>
);

Modal.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ]),
  isActive: PropTypes.bool,
  onClick: PropTypes.func,
  style: PropTypes.object
};

Modal.defaultProps = {
  isActive: false
};

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal.js